<template>
  <div class="allocation-storehouse-history-audit-orders-container">
    <ds-page-header :title="$t('allocationStorehouseHistoryAuditOrders.page.title')"
      :subtitle="$t('allocationStorehouseHistoryAuditOrders.page.subtitle')">
      <template #extra>
        <el-button size="small" icon="el-icon-back" @click="goBack">
          {{ $t('allocationStorehouseHistoryAuditOrders.back') }}
        </el-button>
        <el-button type="primary" size="small" icon="el-icon-refresh" @click="queryAuditOrders">
          {{ $t('allocationStorehouseHistoryAuditOrders.refresh') }}
        </el-button>
      </template>
    </ds-page-header>

    <div class="ds-panel">
      <ds-toolbar :total="page.total" :density="density" :show-column-setting="false"
        @update:density="density = $event" @refresh="listAuditOrders">
        <template #left><span class="ds-panel__title">{{ $t('allocationStorehouseHistoryAuditOrders.title') }}</span></template>
      </ds-toolbar>
      <ds-data-table :data="auditOrders" :loading="loading" :error="hasError" :error-message="errorMessage"
        :density="density" border :empty-description="$t('allocationStorehouseHistoryAuditOrders.page.empty')"
        @retry="listAuditOrders">
        <el-table-column prop="applyId" :label="$t('allocationStorehouseHistoryAuditOrders.allocationNumber')" align="center" min-width="140">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.applyId || '-' }}</span></template>
        </el-table-column>
        <el-table-column prop="applyCount" :label="$t('allocationStorehouseHistoryAuditOrders.allocationCount')" align="center" width="110">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.applyCount }}</span></template>
        </el-table-column>
        <el-table-column prop="startUserName" :label="$t('allocationStorehouseHistoryAuditOrders.applicant')" align="center" min-width="110" />
        <el-table-column prop="stateName" :label="$t('allocationStorehouseHistoryAuditOrders.status')" align="center" width="120">
          <template slot-scope="scope"><ds-status-tag size="sm" type="muted" :label="scope.row.stateName || '-'" /></template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('allocationStorehouseHistoryAuditOrders.time')" align="center" width="170">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.createTime || '-' }}</span></template>
        </el-table-column>
        <el-table-column :label="$t('allocationStorehouseHistoryAuditOrders.operation')" align="center" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="toDetail(scope.row)">{{ $t('allocationStorehouseHistoryAuditOrders.detail') }}</el-button>
          </template>
        </el-table-column>
      </ds-data-table>
      <ds-pagination-bar :page="page.current" :size="page.size" :total="page.total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
import { listAllocationStoreHisAuditOrders } from '@/api/resource/allocationStorehouseHistoryAuditOrdersApi'
import { getCommunityId } from '@/api/community/communityApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'
import DsPaginationBar from '@/components/ds/ds-pagination-bar.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'

export default {
  name: 'AllocationStorehouseHistoryAuditOrdersList',
  components: { DsPageHeader, DsToolbar, DsDataTable, DsPaginationBar, DsStatusTag },
  data() {
    return {
      loading: false, hasError: false, errorMessage: '', density: 'default',
      auditOrders: [],
      page: { current: 1, size: 10, total: 0 },
      conditions: { auditOrdersId: '', userName: '', auditLink: '' },
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.listAuditOrders()
  },
  methods: {
    async listAuditOrders() {
      try {
        this.loading = true
        this.hasError = false
        const params = { page: this.page.current, row: this.page.size, communityId: this.communityId, ...this.conditions }
        const { data, total } = await listAllocationStoreHisAuditOrders(params)
        this.auditOrders = data
        this.page.total = total
      } catch (error) {
        this.hasError = true
        this.errorMessage = this.$t('common.loadError')
        this.$message.error(this.$t('allocationStorehouseHistoryAuditOrders.fetchError'))
      } finally {
        this.loading = false
      }
    },
    queryAuditOrders() { this.page.current = 1; this.listAuditOrders() },
    toDetail(item) { this.$router.push({ path: '/pages/common/allocationStorehouseDetail', query: { applyId: item.applyId } }) },
    goBack() { this.$router.go(-1) },
    handleSizeChange(val) { this.page.size = val; this.listAuditOrders() },
    handleCurrentChange(val) { this.page.current = val; this.listAuditOrders() }
  }
}
</script>

<style lang="scss" scoped>
.allocation-storehouse-history-audit-orders-container { padding: var(--ds-spacing-lg); background-color: var(--ds-gray-100); min-height: calc(100vh - 60px); }
.ds-panel { background: #fff; border: 1px solid var(--ds-gray-300); border-radius: var(--ds-radius-md); box-shadow: var(--ds-shadow-sm); overflow: hidden; margin-bottom: var(--ds-spacing-lg);
  &__title { font-size: var(--ds-font-size-lg); font-weight: 600; color: var(--ds-gray-800); } }
</style>
